import './brandAssets';
import { AuthProvider } from '@greensm/auth';
import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';
import { AppErrorBoundary } from './AppErrorBoundary';
import { ServicesProvider, type Services } from './services';

export function Providers({ services, children }: { services: Services; children: ReactNode }) {
  // Khôi phục phiên một lần khi mở app.
  useEffect(() => { void services.auth.restore(); }, [services]);
  return (
    <AppErrorBoundary>
      <ServicesProvider services={services}>
        <QueryClientProvider client={services.queryClient}>
          <AuthProvider store={services.auth}>{children}</AuthProvider>
        </QueryClientProvider>
      </ServicesProvider>
    </AppErrorBoundary>
  );
}
